import * as React from "react";
import Text from "../text";

interface IProps {
  value: boolean;
  label: string | React.ReactNode;
  mode?: "large" | "small";
  id: any;
  disabled?: boolean;
  required?: boolean;
  horizontallyCentered?: boolean;
  onChange: (value: boolean) => void;
}

const Checkbox = ({
  id,
  value,
  label,
  mode = "large",
  disabled = false,
  horizontallyCentered = true,
  onChange,
}: IProps) => {
  return (
    <div
      className={` flex flex-row ${
        horizontallyCentered ? "items-center" : ""
      }  gap-[10px]   ${
        disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
      }`}
      onClick={() => {
        if (!disabled) {
          onChange(!value);
        }
      }}
    >
      <input
        id={id}
        disabled={disabled}
        checked={value}
        readOnly
        className={` ${
          mode === "large" ? "" : "!w-[18px] !h-[18px]"
        } focus:ring-0 focus:ring-offset-0 !border-none  ${
          disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
        }`}
        type="checkbox"
      />
      <Text
        size={13}
        leading={horizontallyCentered ? 1 : 1.3}
        sizeDesktop={mode == "large" ? 15 : 13}
        sizeTablet={mode == "large" ? 15 : 13}
        weight="normal"
        color="black80"
        className={`${horizontallyCentered ? "" : "mt-[0px]"}`}
      >
        {label}
      </Text>
    </div>
  );
};

export default Checkbox;
